var map = {
	"./arrow-down-pri.png": "878b",
	"./australia.png": "0d2a",
	"./bg-nicosia.png": "25e6",
	"./bg-pp.png": "a6e1",
	"./confidential-clients.png": "d498",
	"./cyprus-confidential.png": "fdf0",
	"./default.png": "113c",
	"./european-union.png": "209d",
	"./img/PP-Box-Coin-V9 1.png": "bbb2",
	"./img/PP-Coin-Banner.png": "244a",
	"./img/avatar.png": "690a",
	"./img/avatars/alexander-abramov-aleksandr-frolov.png": "2617",
	"./img/avatars/alexey-mordashov.png": "9deb",
	"./img/avatars/avatar.png": "bb20",
	"./img/avatars/petr-aven.png": "5026",
	"./img/avatars/rinat-akhmetov.png": "00a0",
	"./img/avatars/roman-abramovich.png": "100c",
	"./img/bg_flags.png": "3ddf",
	"./img/logos/1.png": "928d",
	"./img/logos/10.png": "f6db",
	"./img/logos/11.png": "ab67",
	"./img/logos/12.png": "7972",
	"./img/logos/13.png": "8e80",
	"./img/logos/14.png": "f322",
	"./img/logos/2.png": "2d52",
	"./img/logos/3.png": "6103",
	"./img/logos/4.png": "2d3c",
	"./img/logos/5.png": "1884",
	"./img/logos/6.png": "7359",
	"./img/logos/7.png": "7648",
	"./img/logos/8.png": "21b6",
	"./img/logos/9.png": "a706",
	"./img/logos/default.png": "977a",
	"./img/new-zealand.png": "c88b",
	"./interactive-logo.png": "35bd",
	"./interactive-top.png": "129c",
	"./logo/1x/Asset 9.png": "0af0",
	"./logo/ring.png": "00a8",
	"./logo/shape.png": "a18a",
	"./logo/sign.png": "b8a2",
	"./new-zealand.png": "07c6",
	"./united-kingdom.png": "98cb",
	"./united-states.png": "24e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";